import { AnyAction } from "redux";
import * as actionTypes from "./actionTypes";

export const getFeatured = (): AnyAction => ({
  type: actionTypes.FEATURED_GET_FEATURED,
});
